




































import { defineComponent, reactive, toRefs, ref } from '@vue/composition-api';
import Form from '@/components/Form/index.vue';
import Pagination from '@/components/Pagination';
import addComma from '@/utils/addComma';
import request from '@utils/request';
import { userInfor as userInfoRef, isCore } from '@/useable/login';
const userInfor = userInfoRef.value;

export default defineComponent({
  name: 'billList',
  components: {
    Form,
    Pagination
  },
  setup(props: any, { root }: any) {
    const tableConfig = ref({
      column: [
        {key: 'payCorpName', label: '付款企业'},
        {key: 'supplierName', label: '收款企业'},
        {key: 'orderNo', label: '付款单号', width: 210},
        {key: 'amount', label: '付款金额', width: 130, custom: true, align: 'right', headerAlign: 'right'},
        {key: 'currency', label: '币种', width: 70},
        {key: 'orderTypeName', label: '付款类型', width: 100},
        {key: 'orderStatusName', label: '付款单状态', width: 110},
        {key: 'planPayTime', label: '预计付款日期', width: 110},
        {key: 'c', label: '操作', operate: true, width: 90}
      ],
      data: []
    });
    const state = reactive({
      loginstatus: false,
      form: {
        supplierId: isCore.value?'':userInfor.supplierId,
        supplierName: isCore.value?'':userInfor.supplierName,
        orderStatus: '',
        orderNo: ''
      },
      downloadUrl: 'bill-billExport',
      total: 0,
      pageSize: 10,
      page: 1,
      formSupplierColumn: [
        {
          name: 'supplierName',
          type: 'input',
          label: '企业名称：',
          disabled: true,
          placeholder: '输入企业名称',
        },
        {
          name: 'orderStatus',
          type: 'select',
          label: '付款单状态：',
          placeholder: '',
          options: [
            {
              name: '全部',
              value: ''
            },
            {
              name: '付款单提交',
              value: '0'
            },
            {
              name: '发票已签收',
              value: '1'
            },
            {
              name: '发票审核',
              value: '2'
            },
            {
              name: '推送付款',
              value: '3'
            },
            {
              name: '已收款',
              value: '4'
            },
            {
              name: '付款失败',
              value: '5'
            },
          ]
        },
        {
          name: 'orderNo',
          type: 'input',
          label: '付款单号：',
          placeholder: '输入结算单号',
          options: [],
        }
      ],
      formBusinessColumn: [
        {
          name: 'supplierId',
          type: 'remote',
          label: '供应商名称：',
          placeholder: '输入供应商名称',
          options:[]
        },
        {
          name: 'orderStatus',
          type: 'select',
          label: '付款单状态：',
          placeholder: '',
          options: [
            {
              name: '全部',
              value: ''
            },
            {
              name: '付款单提交',
              value: '0'
            },
            {
              name: '发票已签收',
              value: '1'
            },
            {
              name: '发票审核',
              value: '2'
            },
            {
              name: '推送付款',
              value: '3'
            },
            {
              name: '已收款',
              value: '4'
            },
            {
              name: '付款失败',
              value: '5'
            },
          ]
        },
        {
          name: 'orderNo',
          type: 'input',
          label: '付款单号：',
          placeholder: '输入结算单号',
          options: [],
        }
      ]
    });
    const getBillList = async () => {
      const parms = {
        supplierId: isCore.value?state.form.supplierId:userInfor.supplierId,
        orderNo: state.form.orderNo,
        current: state.page,
        size: state.pageSize,
        orderStatus: state.form.orderStatus
      };
      const res = await request('bill', 'getBillList', parms);
      if (res.code === 2000) {
        tableConfig.value.data = res.data.records;
        state.total = res.data.total;
      }
    };
    const getSupplierInfoSelect = async (query) => {
      const parms = {
        name: query,
        current: 1,
        size:10
      };
      const res = await request('bill', 'getSupplierInfoSelect', parms);
      if (res.code === 2000) {
        state.formBusinessColumn[0].options = res.data;
      }
    };
    if (isCore.value){
      getSupplierInfoSelect('');
      state.loginstatus = false;
    } else {
      state.loginstatus = true;
    }
    getBillList();
    const submit = async () => {
      getBillList();
    };

    const pageChange = (newPage, newSize) => {
      state.page = newPage;
      state.pageSize = newSize;
      submit();
    };

    const onSearch = (val) => {
      state.form = val;
      state.page = 1;
      // state.pageSize = 10;
      submit();
    };
    const checkDetail = (data) => {
      // root.$router.push({
      //   path: '/bill/detail',
      //   query: {
      //     orderNo: data
      //   }
      // });
      const routeUrl = root.$router.resolve(`/bill/detail/${data}`);
      window.open(routeUrl.href, '_blank');
    };
    return {
      ...toRefs(state),
      pageChange,
      onSearch,
      tableConfig,
      getBillList,
      checkDetail,
      getSupplierInfoSelect,
      addComma
    };
  },
});
